import { useState } from 'react';

import MessageInfoIcon from '@svg/message-info.svg';
import { Button } from '@ui/Button';
import { Image } from '@ui/Image';
import { CharacteristicOverviewModal } from '@components/CharacteristicOverviewModal';
import { FeedFilterTitle } from '@components/FeedFilterTitle';

import s from './FeedCharacteristicsFilterTitle.sss';

interface Option {
  title: string,
  id: number,
  description?: string | null,
  icon?: string | null,
}

interface Props {
  title: string,
  icon?: string,
  hide: boolean,
  options?: Option[],
  onClick: () => void,
}

export const FeedCharacteristicsFilterTitle: React.FC<Props> = ({
  title,
  icon,
  hide,
  options = [],
  onClick,
}) => {
  const [isOverviewModalOpen, setIsOverviewModalOpen] = useState(false);
  const optionsWithDescription = options?.filter((option) => option.description);

  return (
    <>
      <FeedFilterTitle
        title={(
          <span className={s.label}>
            {!!icon && (
              <Image
                className={s.icon}
                src={icon}
                width="24"
                height="24"
              />
            )}
            <span className={s.title}>
              {title}
            </span>

            {!!optionsWithDescription.length && (
              <Button
                className={s.iconButton}
                theme="text"
                onClick={() => setIsOverviewModalOpen(true)}
              >
                <MessageInfoIcon
                  width="16"
                  height="16"
                />
              </Button>
            )}
          </span>
        )}
        hide={hide}
        onClick={onClick}
      />
      <CharacteristicOverviewModal
        isOpen={isOverviewModalOpen}
        title={title}
        options={options}
        onClose={() => setIsOverviewModalOpen(false)}
      />
    </>
  );
};
